import React from 'react';
export const defaultAnimationConfig = { glassmorphism: true, breathing: true, gradientBorder: true };
const AnimationContext = React.createContext(defaultAnimationConfig);
export const AnimationContextProvider = (props) => {
    const { breathing, glassmorphism, gradientBorder, children } = props;
    const mergedValue = {
        gradientBorder: gradientBorder === undefined ? defaultAnimationConfig.gradientBorder : gradientBorder,
        breathing: breathing === undefined ? defaultAnimationConfig.breathing : breathing,
        glassmorphism: glassmorphism === undefined ? defaultAnimationConfig.glassmorphism : glassmorphism
    };
    return React.createElement(AnimationContext.Provider, { value: mergedValue }, children);
};
export const ConfigAnimationStyle = {
    glassmorphism: {
        modal: {
            backgroundColor: 'rgba(, #474a52, 0.6)',
            backdropFilter: 'blur(4px) saturate(2.1)'
        },
        drodown: {
            backgroundColor: 'rgba(var(--white, white), 0.85)',
            backdropFilter: 'blur(6px) saturate(2.1)' // 模糊6像素，饱和度2.1
        }
    }
};
export default AnimationContext;
